import React, { useRef, useEffect, useState } from "react";
import AnimateHeight from "react-animate-height";
import uniqueId from "lodash.uniqueid";

import { string, object, number, arrayOf, shape, func, bool } from "prop-types";

import cx from "classnames";

import ArrowLink from "../../components/ArrowLink/ArrowLink.jsx";
import PlusIcon from "../../components/PlusIcon/PlusIcon.jsx";

const propTypes = {
  items: arrayOf(
    shape({
      amountString: string,
      description: string,
      link: object,
    }),
  ),
  note: string,
  activeItemIndex: number,
  setActiveItemIndex: func,
};

const FundingInterface = (props) => {
  const { items, note, activeItemIndex, setActiveItemIndex } = props;
  const animationTime = 500;
  const [baseId, setBaseId] = useState(uniqueId());

  const focusRef = useRef();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (focusRef.current && activeItemIndex >= 0) {
        focusRef.current.focus();
      }
    }, 10);

    return () => clearTimeout(timer);
  }, [activeItemIndex]);

  return (
    <section className="funding-interface">
      <div className="funding-interface__list-container">
        <ul className="funding-interface__list-items">
          {items.map((item, i) => {
            return (
              <li key={i}>
                <button
                  className={cx("funding-interface__button btn", {
                    "funding-interface__button--active": i === activeItemIndex,
                  })}
                  ref={i === activeItemIndex ? focusRef : null}
                  id={`fi-button-${baseId}-${i}`}
                  aria-controls={`fi-panel-${baseId}-${i}`}
                  aria-expanded={i === activeItemIndex ? true : false}
                  onClick={() => setActiveItemIndex(i)}
                >
                  <span
                    className="funding-interface__bullet"
                    aria-hidden={true}
                  >
                    {String.fromCharCode("A".charCodeAt(0) + i)}.
                  </span>
                  &nbsp;
                  <span className="funding-interface__name">{item.name}</span>
                  <PlusIcon />
                </button>
                <AnimateHeight
                  duration={animationTime}
                  animateOpacity={true}
                  height={i === activeItemIndex ? "auto" : 0}
                >
                  <div
                    className="funding-interface__content"
                    aria-labelledby={`fi-button-${baseId}-${i}`}
                    id={`fi-panel-${baseId}-${i}`}
                  >
                    <div className="funding-interface__amount">
                      {item.amountString}
                    </div>
                    <div
                      className="funding-interface__description"
                      dangerouslySetInnerHTML={{
                        __html: item.description,
                      }}
                    ></div>
                    <div className="funding-interface__link">
                      <ArrowLink {...item.link} />
                    </div>
                  </div>
                </AnimateHeight>
              </li>
            );
          })}
        </ul>
      </div>
      {note && <div className="funding-interface__note">{note}</div>}
    </section>
  );
};
FundingInterface.propTypes = propTypes;
export default FundingInterface;
